import { render, staticRenderFns } from "./fab.vue?vue&type=template&id=3a673166&scoped=true"
import script from "./fab.vue?vue&type=script&lang=ts"
export * from "./fab.vue?vue&type=script&lang=ts"
import style0 from "./fab.vue?vue&type=style&index=0&id=3a673166&prod&lang=less"
import style1 from "./fab.vue?vue&type=style&index=1&id=3a673166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a673166",
  null
  
)

export default component.exports